import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from '../auth';

@Injectable()
export class AuthenticationInterceptor implements HttpInterceptor {

  constructor(
    private authService: AuthService
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(this.authenticate(request));
  }

  private authenticate(request: HttpRequest<any>) {
    const accessToken = this.authService.getAccessToken();
    // Clone immutable request with access token
    return request.clone({
      setHeaders: {
          'Authorization': `Bearer ${accessToken}`,
      }
    });
  }
}
